import { render } from "./TitleDesc.vue?vue&type=template&id=429b416d&ts=true"
import script from "./TitleDesc.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDesc.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/TitleDesc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "429b416d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('429b416d', __exports__)) {
    api.reload('429b416d', __exports__)
  }
  
  module.hot.accept("./TitleDesc.vue?vue&type=template&id=429b416d&ts=true", () => {
    api.rerender('429b416d', render)
  })

}


export default __exports__